import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';
import { environment } from './environments/environment';

// msal-browser 5 liest die Antwort im Microsoft-Popup und im iframe der stillen Anmeldung nicht mehr
// selbst aus: Die Redirect-Seite muss sie ans Hauptfenster weiterreichen, sonst läuft loginPopup in
// timed_out. Die App lädt sie dafür gar nicht erst – das iframe hat nur 10 s, bis MSAL aufgibt.
function isMsalRedirectResponse(): boolean {
  if (window.location.pathname !== new URL(environment.msalConfig.redirectUri).pathname) return false;
  const params = new URLSearchParams(window.location.hash.substring(1) || window.location.search.substring(1));
  return params.has('state') && (params.has('code') || params.has('error'));
}

const startApp = () => import('./bootstrap').then(app => app.bootstrap());

if (isMsalRedirectResponse()) {
  broadcastResponseToMainFrame().catch(err => {
    console.error('[MSAL] Antwort konnte nicht ans Hauptfenster übergeben werden', err);
    startApp();
  });
} else {
  startApp();
}
